import {createAsyncStoragePersister} from '@tanstack/query-async-storage-persister';
import {Query, QueryClient} from '@tanstack/react-query';
import {persistQueryClient} from '@tanstack/react-query-persist-client';

import {storage} from '@/services/storage';
import {CACHE_EXCLUDED_KEYS} from '@/types/queryKeys';

const CACHE_VERSION = 22;
const CACHE_STORAGE_KEY = 'EMBED_REACT_QUERY_OFFLINE_CACHE';
const getStorageKey = (version: number) => `${CACHE_STORAGE_KEY}_v${version}`;

const CACHE_TIME = Infinity;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: CACHE_TIME,
    },
  },
});

const persister = createAsyncStoragePersister({
  key: getStorageKey(CACHE_VERSION),
  storage,
  // @ts-ignore - on web we use indexedDB for storage. It doesn't require serialization so it's ok to return pure data
  serialize: data => data,
  deserialize: (cachedData: any) => ({
    ...cachedData,
    clientState: {
      ...cachedData.clientState,
      queries: cachedData.clientState.queries.filter(
        // @ts-ignore
        (query: Query) => !CACHE_EXCLUDED_KEYS.includes(query.queryKey[0]),
      ),
    },
  }),
});

const clearDeprecatedCache = async () => {
  try {
    // remove legacy cache
    if (CACHE_VERSION > 1) {
      await Promise.all(
        Array.from({length: CACHE_VERSION - 1}).map((_, i) =>
          storage.removeItem(getStorageKey(i + 1)),
        ),
      );
    }
  } catch (error) {
    //ignore error
  }
};

export const setupReactQuery = (): Promise<void> => {
  clearDeprecatedCache();

  const [, restore] = persistQueryClient({
    queryClient,
    persister,
    maxAge: CACHE_TIME,
  });

  return restore;
};
